<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20036_571442)">
      <path
        d="M16.8188 2.37121C16.7624 2.32663 16.6967 2.29565 16.6267 2.28065C16.5567 2.26565 16.4843 2.267 16.4149 2.28462L11.5647 3.51277L6.70196 1.05011C6.60141 0.999316 6.48623 0.986635 6.37725 1.01437L1.35765 2.28541C1.25575 2.31093 1.1652 2.37021 1.1004 2.45384C1.0356 2.53747 1.00026 2.64065 1 2.74696V14.1864C0.999996 14.2588 1.01631 14.3304 1.04769 14.3955C1.07908 14.4606 1.12471 14.5176 1.18112 14.5622C1.23754 14.6068 1.30324 14.6377 1.37324 14.6527C1.44324 14.6677 1.5157 14.6664 1.5851 14.6487L6.43529 13.4206L11.298 15.8832C11.3986 15.934 11.5138 15.9467 11.6227 15.919L16.6424 14.6479C16.7442 14.6224 16.8348 14.5631 16.8996 14.4795C16.9644 14.3959 16.9997 14.2927 17 14.1864V2.74696C17 2.6745 16.9837 2.603 16.9523 2.53789C16.9209 2.47277 16.8752 2.41577 16.8188 2.37121ZM6.96078 2.24728L11.0392 4.31273V14.6861L6.96078 12.6206V2.24728ZM1.94118 3.12112L6.01961 2.0884V12.5435L1.94118 13.5763V3.12112ZM16.0588 13.8146L11.9804 14.8473V4.38979L16.0588 3.35706V13.8146Z"
        class="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_20036_571442">
        <rect
          width="16.0586"
          height="16.0586"
          fill="white"
          transform="translate(0.724365 0.670288)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "InviteIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
